export const linkIconStyle = 'min-w-6 min-h-6';
//# sourceMappingURL=linkIconStyle.js.map